module.exports = __webpack_public_path__ + "img/order-play.5dc014e1.png";